import { Directive, ElementRef, Input, OnDestroy, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { MonitorChangeViewService } from '../services/http-services/monitor-change-view.service';
import { AuthService } from '../services/auth/auth.service';

@Directive({
  selector: 'img[imageSrc]',
  standalone: true
})
export class ImageSrcDirective implements OnDestroy {
  private _src: string;
  private subscription = new Subscription();
  private currentObjectUrl: string;

  @Input('imageSrc')
  set src(value: string) {
    if (value && value !== this._src) {
      this._src = value;
      this.loadImage(value);
    }
  }

  constructor(
    private el: ElementRef<HTMLImageElement>,
    private sanitizer: DomSanitizer,
    private monitorChangeViewService: MonitorChangeViewService,
    private authService: AuthService
  ) { }

  ngOnDestroy(): void {
    this.destroySub();
  }

  private loadImage(url: string) {
    this.destroySub();

    this.subscription = this.monitorChangeViewService.getSnapshot(url, !this.authService.userId).pipe(
      map(blob => {
        this.currentObjectUrl = URL.createObjectURL(blob);
        return this.sanitizer.sanitize(
          SecurityContext.URL,
          this.sanitizer.bypassSecurityTrustUrl(this.currentObjectUrl));
      })
    )
    .subscribe(safeUrl => this.el.nativeElement.src = safeUrl);
  }

  private destroySub() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (this.currentObjectUrl) {
      URL.revokeObjectURL(this.currentObjectUrl);
    }
  }

}
